/* eslint-disable no-param-reassign */

import { createSlice } from '@reduxjs/toolkit';
import { useSelector } from 'react-redux';
import listSaga from './list';
import byIdSaga from './byId';
import createSaga, { BusinessCreateData } from './create';
import updateSaga, { BusinessUpdateData } from './update';
import deleteSaga from './delete';
import { BaseState, createCRUDModel, createCRUDStates } from '../creator';
import { RootState } from '../index';
import { GetFileResponseDto, PaginatedResponse } from '../types';
import { User } from '../auth';
import { CategoryById } from '../category_example/byId';
import { SubCategoryById } from '../../hooks/api/subCategories';

export const moduleName = 'business';

export type BusinessStatus = 'published' | 'deactivated' | 'draft';
export const BusinessStatusTitle: Record<BusinessStatus, string> = {
  published: 'Published',
  deactivated: 'Deactivated',
  draft: 'Draft',
};

export interface Business {
  id: string;
  name: string;
  description: string
  email: string
  zipCode: string
  type: string
  website: string
  address: string
  schedule: string
  phone: string
  status: BusinessStatus;
  file: GetFileResponseDto | null;
  createdAt: string;
  updatedAt: string;
  owner: User | null;
  ownerId: string | null;
  categories: CategoryById[],
  subCategories: SubCategoryById[]
}

export interface State {
  list: BaseState<PaginatedResponse<Business>>,
  byId: BaseState<Business>,
  create: BaseState<BusinessCreateData>,
  update: BaseState<BusinessUpdateData>,
  delete: BaseState<{ id: string }>
}

const models = ['list', 'byId', 'create', 'update', 'delete'];

export const defaultState: State = createCRUDStates<State>(models);

export const business = createSlice({
  name: moduleName,
  initialState: defaultState,
  reducers: createCRUDModel(models, moduleName),
});

export const { actions } = business;

export function useBusiness(): State {
  return useSelector((state: RootState) => state[moduleName]);
}

export function* saga() {
  yield* listSaga();
  yield* byIdSaga();
  yield* createSaga();
  yield* updateSaga();
  yield* deleteSaga();
}
